import { QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra';
import { PremiumStoreApiClient } from '@wix/premium-fed-sdk/api-clients-react';
const service = {
  baseUrl: '',
  defaultHttpMethod: 'post',
  defaultQueryConfigType: QueryConfigTypes.DYNAMIC_DATA
};
export const UserOfferingApiAggregations = {
  listUserOfferings: {
    name: 'listUserOfferings',
    service,
    queryFn: async _ref => {
      let {
        httpClient,
        request
      } = _ref;
      const {
        getUserOffering
      } = PremiumStoreApiClient.queries({
        httpClient
      });
      const userOfferingPromises = request.productTypeIds.map(productTypeId => getUserOffering({
        productTypeId
      }).then(userOffering => ({
        productTypeId,
        userOffering
      })));

      // TODO - error handling
      return {
        userOfferings: await Promise.all(userOfferingPromises)
      };
    }
  }
};
//# sourceMappingURL=user-offering-aggregations.api-config.js.map